"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const styles_1 = require("@material-ui/core/styles");
const react_1 = tslib_1.__importStar(require("react"));
const style_1 = tslib_1.__importDefault(require("../utils/style"));
function MultiValuedTextField(props) {
    const [existingColumns, setExistingColumns] = react_1.useState([]);
    const [dropDownOpen, setDropDownOpen] = react_1.useState(false);
    const styleLocal = style_1.default();
    const readColumns = (event, newValue) => {
        props.addColumns(newValue);
        setDropDownOpen(false);
    };
    react_1.useEffect(() => {
        if (props.existingColumns) {
            setExistingColumns([...props.existingColumns]);
        }
    }, [props.existingColumns]);
    const { columns = [] } = props;
    return (react_1.default.createElement(lab_1.Autocomplete, { options: existingColumns, freeSolo: true, multiple: true, disableClearable: true, size: "small", value: columns, onChange: (event, newValue) => readColumns(event, newValue), open: dropDownOpen, onInputChange: (event, newInputValue) => {
            setDropDownOpen(Boolean(newInputValue.trim()));
        }, PaperComponent: (props) => react_1.default.createElement(core_1.Paper, Object.assign({}, props, { elevation: 10 })), style: { marginBottom: "15px", width: "100%" }, renderInput: (params) => (react_1.default.createElement(exports.CustomTextInput, Object.assign({ variant: "outlined", placeholder: "Type the column name here" }, params, { helperText: props.helperText, error: props.error, InputLabelProps: {
                shrink: false,
            }, InputProps: Object.assign({}, params.InputProps, { autoComplete: "off", startAdornment: (Array.isArray(columns) ? columns : []).map((value, index) => (react_1.default.createElement(core_1.Chip, { key: index, label: value, onDelete: () => {
                        props.removeColumn(index);
                    }, className: styleLocal.chipStyle, deleteIcon: react_1.default.createElement("i", { className: "fa fa-times cloud-item-close", style: {
                            fontSize: "14px",
                            cursor: "pointer",
                            color: "#FF4E4E",
                        } }) }))), sx: {
                    borderRadius: "8px",
                    border: props.error ? "1px solid red " : "none",
                    "&:hover fieldset": {
                        border: "1px solid #C4C4C4 !important",
                    },
                    "&.Mui-focused fieldset": {
                        border: "1px solid #C4C4C4 !important",
                    },
                } }) }))) }));
}
exports.MultiValuedTextField = MultiValuedTextField;
exports.CustomTextInput = styles_1.styled(core_1.TextField)(({ theme, error }) => ({
    width: "100%",
    "& .MuiAutocomplete-input": {
        position: "relative",
        fontSize: 14,
        color: "#777E90",
    },
}));
//# sourceMappingURL=multi-valued-text-field.js.map